import { render, staticRenderFns } from "./MedicalSimService.vue?vue&type=template&id=e220978c&scoped=true"
import script from "./MedicalSimService.vue?vue&type=script&lang=js"
export * from "./MedicalSimService.vue?vue&type=script&lang=js"
import style0 from "./MedicalSimService.vue?vue&type=style&index=0&id=e220978c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e220978c",
  null
  
)

export default component.exports